import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

/**
 * Cliente del middleware de pagos (fn-api).
 *
 * Reemplaza al backend legacy `lipatin-pagos-fn`:
 *   testStartPay (POST)            -> POST /payments
 *   getPayment  (POST + body)      -> GET  /payments/{paymentId}
 *
 * El middleware responde 201 al crear y 200 al consultar; usar `isOk()` para
 * evaluar la respuesta en vez de comparar contra 200.
 */
/**
 * El middleware responde 201 al crear un pago y 200 en el resto de operaciones.
 * El legacy siempre respondia 200, por eso los componentes comparaban contra ese
 * valor; usar este helper en su lugar.
 */
export function isPaymentApiOk(code: number): boolean {
  return code === 200 || code === 201;
}

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private readonly http = inject(HttpClient);

  /**
   * La clave del middleware de pagos se fija aqui a proposito: `apiKeyInterceptor`
   * respeta cualquier peticion que ya traiga la cabecera y no la sobrescribe.
   */
  private paymentHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Subscription-Key': environment.apiManagementConfig.pagosApi,
    });
  }

  startPayment(paymentInit: unknown): Observable<any> {
    return this.http.post(`${environment.apiPagos}/payments`, paymentInit, {
      headers: this.paymentHeaders(),
    });
  }

  getPaymentById(paymentId: string): Observable<any> {
    return this.http.get(`${environment.apiPagos}/payments/${paymentId}`, {
      headers: this.paymentHeaders(),
    });
  }

  /**
   * Reinicia un pago rechazado: el middleware emite una referencia y una firma
   * nuevas contra PayU y reabre el mismo paymentId.
   */
  retryPayment(paymentId: string): Observable<any> {
    return this.http.post(
      `${environment.apiPagos}/payments/${paymentId}/retry`,
      {},
      { headers: this.paymentHeaders() },
    );
  }
}
